import buttonStyle from '../../../../materialUI/components/CustomButtons/buttonStyle'

const panelSurface = {
  backgroundColor: '#ffffff',
  border: '1px solid #d7dfeb',
  borderRadius: '8px',
  boxShadow: '0 12px 30px rgba(17, 37, 63, 0.08)',
}

const styles = {
  ...buttonStyle,
  buttonGrid: {
    marginTop: '20px',
  },
  componentPanel: {
    marginTop: '0px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  drawerPaper: {
    width: { xs: '100vw', sm: '640px' },
    maxWidth: '100vw',
    backgroundColor: '#f4f7fb',
  },
  drawerForm: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 2,
    padding: '28px 32px',
    borderBottom: '1px solid #dbe3ef',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(244,247,251,0.96) 100%)',
  },
  drawerEyebrow: {
    marginBottom: '10px',
    color: '#58708f',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
  },
  drawerTitle: {
    color: '#14253d',
    fontWeight: 700,
    lineHeight: 1.1,
  },
  drawerSubtitle: {
    marginTop: '10px',
    maxWidth: '40ch',
    color: '#66768a',
    lineHeight: 1.5,
  },
  closeButton: {
    alignSelf: 'flex-start',
    color: '#4f6480',
    border: '1px solid #d7dfeb',
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#eef3f8',
    },
  },
  drawerBody: {
    flex: 1,
    overflowY: 'auto',
    padding: '24px 32px 16px',
  },
  formSection: {
    ...panelSurface,
    padding: '24px',
    marginBottom: '20px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 2,
    marginBottom: '20px',
  },
  sectionTitle: {
    color: '#1a2e49',
    fontSize: '1rem',
    fontWeight: 700,
  },
  sectionDescription: {
    marginTop: '6px',
    color: '#6b7b8f',
    fontSize: '0.9rem',
    lineHeight: 1.45,
  },
  routeNameInput: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#f9fbfd',
      borderRadius: '14px',
    },
  },
  mapCard: {
    ...panelSurface,
    padding: '16px',
    backgroundColor: '#f9fbfd',
  },
  mapTitle: {
    marginBottom: '12px',
    color: '#1f3553',
    fontWeight: 700,
  },
  locationCard: {
    height: '100%',
    padding: '20px',
    borderRadius: '16px',
    border: '1px solid #d7dfeb',
    backgroundColor: '#fbfcfe',
  },
  locationCardRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'center' },
    gap: '20px',
  },
  locationCardCopy: {
    flex: { md: '0 0 100px' },
  },
  locationTitle: {
    color: '#1f3553',
    fontSize: '0.95rem',
    fontWeight: 700,
  },
  locationSubtitle: {
    marginTop: '4px',
    color: '#748397',
    fontSize: '0.8rem',
    lineHeight: 1.45,
  },
  locationSearchWrap: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    minWidth: 0,
  },
  switchControl: {
    margin: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: { xs: '100%', md: '220px' },
    gap: '12px',
  },
  switchLabel: {
    color: '#22344d',
    fontSize: '0.84rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  pricingRow: {
    alignItems: 'stretch',
  },
  priceInput: {
    '& .MuiOutlinedInput-root': {
      height: '100%',
      minHeight: '56px',
      backgroundColor: '#f9fbfd',
      borderRadius: '8px',
    },
  },
  drawerFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
    padding: '20px 32px 28px',
    borderTop: '1px solid #dbe3ef',
    backgroundColor: '#ffffff',
  },
  footerActionGroup: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  closeAction: {
    color: '#4e6582',
    fontWeight: 600,
    textTransform: 'none',
  },
  secondaryAction: {
    minHeight: '46px',
    padding: '0 20px',
    borderRadius: '6px',
    borderColor: '#c6d1df',
    color: '#fff',
    fontWeight: 700,
    textTransform: 'none',
  },
  primaryAction: {
    minHeight: '46px',
    padding: '0 24px',
    borderRadius: '6px',
    backgroundColor: '#2f5f91',
    color: '#fff',
    boxShadow: '0 10px 24px rgba(47, 95, 145, 0.24)',
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#284f77',
      boxShadow: '0 14px 26px rgba(40, 79, 119, 0.28)',
    },
  },
  addressSearchStyles: {
    container: (provided: any) => ({
      ...provided,
      width: '100%',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 56,
      borderRadius: '8px',
      borderColor: state.isFocused ? '#6e8fb3' : '#cad4e1',
      boxShadow: state.isFocused
        ? '0 0 0 3px rgba(110, 143, 179, 0.14)'
        : 'none',
      backgroundColor: '#ffffff',
      '&:hover': {
        borderColor: '#6e8fb3',
      },
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: '0 14px',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: '#7f8da0',
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      backgroundColor: '#d6dee8',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: '#7890ab',
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: 14,
      overflow: 'hidden',
      boxShadow: '0 16px 40px rgba(17, 37, 63, 0.16)',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#edf3f9' : '#ffffff',
      color: '#20344d',
      cursor: 'pointer',
    }),
    groupHeading: (provided: any) => ({
      ...provided,
      color: '#6b7b8f',
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    }),
  },
}

export default styles
